import moment from 'moment-timezone';

export const getDate = (date: string) =>
  moment(date.split('T')[0]).format('YYYY-MM-DD');
